import { render } from "./BaseHeader.vue?vue&type=template&id=2aa6d36d"
import script from "./BaseHeader.vue?vue&type=script&lang=js"
export * from "./BaseHeader.vue?vue&type=script&lang=js"
script.render = render

export default script